import type { AxiosError } from 'axios';
import type { DocumentPickerAsset } from 'expo-document-picker';
import type { ImagePickerAsset } from 'expo-image-picker';
import { Platform } from 'react-native';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';
import type { Reservation } from '@/api/reservations';

export type TollSubmission = {
  entryPlazaName: string;
  exitPlazaName?: string;
  entryDate: string;
  exitDate?: string;
  amount: string;
};

type Variables = {
  id: number;
  tolls: TollSubmission[];
  images: ImagePickerAsset[] | DocumentPickerAsset[];
};
export type CreateTollsResponse = {
  data: Reservation;
};

export const useCreateTolls = createMutation<
  CreateTollsResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) => {
    const formData = new FormData();

    variables.tolls.forEach((toll, index) => {
      formData.append(`tolls[${index}][start_name]`, toll.entryPlazaName);
      formData.append(`tolls[${index}][end_name]`, toll.exitPlazaName || '');
      formData.append(`tolls[${index}][start_timestamp]`, toll.entryDate);
      if (toll.exitDate) {
        formData.append(`tolls[${index}][end_timestamp]`, toll.exitDate);
      }
      formData.append(`tolls[${index}][amount]`, toll.amount.toString());
    });

    variables.images.forEach(
      (image: ImagePickerAsset | DocumentPickerAsset) => {
        if (Platform.OS === 'web') {
          formData.append('images[]', image); // Append the file object directly for web
        } else {
          formData.append('images[]', {
            uri: image.uri,
            name: image.fileName || image.name,
            type: image.mimeType || 'image/jpeg',
          });
        }
      }
    );

    return client({
      url: `v2/internal/partners/reservations/${variables.id}/tolls`,
      method: 'POST',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        console.error('yoyo', err);
        throw new Error(err.response.data.errors.join(', '));
      });
  },
});
